require.register("app/restaurant/CopyModal", function(exports, require, module){
  $0
  
});

